<template>
  <div class="content has-text-centered">
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <figure class="image" style="display: inline-block;">
            <img src="~assets/images/vti.png" alt="Image1" style="height: 100px; width: auto;"/>
            <!--<img src="http://placehold.it/128x128" alt="Image">-->
          </figure>
          <div class="columns is-vcentered">
            <div class="column is-4 is-offset-4">
              <div class="box">
                <div v-show="error" class="column has-text-centered" style="color:red; word-wrap:break-word;">
                  {{ error }}
                  <br>
                </div>
                <form v-on:submit.prevent="onSubmit" novalidate>
                  <label class="label">Enter your email address to reset your password.</label>
                  <p class="control">
                    <input v-model="email"
                           class="input"
                           type="text"
                           placeholder="Email"
                           v-validate="'required'"
                           name="Email">
                    <span v-show="errors.has('Email')" class="help is-danger">{{ errors.first('Email') }}</span>
                  </p>
                  <div class="column">
                    <div class="has-text-right">
                        <router-link :to="'/Login'">Back to Login</router-link>
                    </div>
                  </div>
                  <hr>
                  <p class="has-text-centered">
                    <button type="submit"
                            class="button is-primary" :disabled="disableButton">Reset Password</button>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </article>
        <alertModal :visible="showModal" :title="'Message'" :message="message" :okText="'OK'" :ok="closeModalBasic" @close="closeModalBasic"></alertModal>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AuthenticationService from './../../services/authenticationservice'
import alertModal from '../../views/components/modals/AlertModal'
import LoadModal from '../../views/components/modals/LoadModal.vue'
import VeeValidate from 'vee-validate'
import Global from '../../services/globalservice'

Vue.use(VeeValidate, Global.VALIDATE_CONFIG)

export default {
  data () {
    return {
      email: '',
      error: '',
      message: null,
      disableButton: false,
      showModal: false,
      openLoadModal: null
    }
  },

  components: {
    alertModal
  },

  computed: {
    validation () {
      return {
        email: !!this.email.trim()
      }
    }
  },

  methods: {
    onSubmit () {
       this.$validator.validateAll().then((result) => {
         if (result) {
           if (this.validation.email) {
             var credentials = {
               data: this.email.trim()
             }
             var self = this
             this.disableButton = true
             self.showLoad()
             AuthenticationService.sendMailForgotPassword(this, credentials, function (response) {
               self.hideLoad()
               self.error = response.status === 'fail' ? response.message : null
               if (response.status === 'success') {
                 self.message = 'Email sent successfully. Please check your mailbox.'
                 self.showModal = true
               }
               self.disableButton = false
             })
           }
         }
       })
    },

    closeModalBasic: function () {
      this.showModal = false
    },

    showLoad () {
      const LoadModalComponent = Vue.extend(LoadModal)
      var propsData = {
        visible: true
      }
      this.openLoadModal = new LoadModalComponent({
        el: document.createElement('div'),
        propsData
      })
    },

    hideLoad () {
      this.openLoadModal.deactive()
    }
  }
}
</script>

<style lang="scss" scoped>
.is-title {
  text-transform: capitalize;
}
.text-success {
  color: #3273dc;
}
.text-danger {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?07009005